import { jsx } from "react/jsx-runtime";
const RevealOnScroll = ({
  animation: Animation,
  children,
  group = false,
  ...props
}) => {
  return /* @__PURE__ */ jsx(Animation, { ...props, children: group ? /* @__PURE__ */ jsx("div", { children }) : children });
};
RevealOnScroll.DAMPLING = {
  FASTEST: 0.1,
  FAST: 0.3,
  MEDIUM: 0.5,
  SLOW: 0.7,
  SLOWEST: 1
};
const RevealOnScroll$1 = RevealOnScroll;
export {
  RevealOnScroll$1 as default
};
